export default __webpack_public_path__ + "static/media/L.b841c706.svg";